import { Component, Input, forwardRef, ElementRef, HostBinding } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare let $: any;

@Component({
	selector: 'nm-input',
	templateUrl: './input.html',
	providers: [
		{
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: forwardRef(() => NmInput),
	    multi: true,
	  }
  ]
})
export class NmInput implements ControlValueAccessor {
	@Input() class: string = 'col-sm-12 no-padding';
	@Input() placeholder: string = '';
	@Input() type: string = 'text';
	@Input() readonly: boolean = false;
	@Input() value: any;

	// label in error prompt
	@Input() errorLabel: string;
	@HostBinding('attr.errorLabel') _errorLabel: string;

	public name: string = '';
	public errorMessage: string = null;

	public constructor(
		public elementRef: ElementRef
	) {
		this.name = $(this.elementRef.nativeElement).attr('formControlName');
	}

	// get form control name for for validation
	public ngAfterViewInit(): void {
		setTimeout(() => {
			if(this.value) this._value = this.value;
			if(this.errorLabel) this._errorLabel = this.errorLabel;
		}, 1);
	}

	// ngModel binding
	public _value: any;

	// placeholder for registerOnChange function
	// just to emit changes back to the form
	public onChange(_: any): void {}

	// placeholder for registerOnTouched function
	// just to emit changes back to the form
	public onTouched(): void {}

	// set initial value
	// e.g. set default value from new formControl(<default_value>)
	// allow undefined for the value to trigger false from Validator.required
	public writeValue(value: any): void {
		this._value = value;
	}

	// ControlValueAccessor interface
	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	// ControlValueAccessor interface
	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	// ControlValueAccessor interface
	public setDisabledState(isDisabled: boolean): void {
		$(this.elementRef.nativeElement).find('input').prop('disabled', isDisabled);
	}

	// change event from input
	// update Angular onChange function with _value
	public onInputChange(event: any): void {
		if(this.type == 'file'){
			let _obj = this;
			let file = $(this.elementRef.nativeElement).find('input')[0].files[0];
			let reader = new FileReader(); 
			reader.readAsDataURL(file);
			reader.onload = function(e){
				//console.log(this.result);
				_obj.onChange(this.result);
			}

//console.log($(this.elementRef.nativeElement).find('input')[0].files[0]);
		}else{
this.onChange(this._value);
		}
		
	}

	// blur event from input
	public onInputTouched(event: any): void {
		this.onTouched();
	}

	// control style
	// set min-height to 0px if hidden
	public isHidden = (): string => {
		return this.type == 'hidden'? '0px': '1px';
	}
}


// WEBPACK FOOTER //
// ./src/widgets/input/input.ts